import React, { useContext} from 'react';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config.js';
import { DialogContentText } from '@mui/material';
import useNotification from '../../../hooks/useNotification.js';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function DeletePoiDialog(props) {

    const auth = useContext(AuthContext);
    const { notificationSuccess, notificationError } = useNotification();

    const deletePoi = async() => {
        try {
            if(!props.lastCellData.idEntita.S)return;

            const essentialData = {
                idEntita: props.lastCellData.idEntita.S,
                city: props.lastCellData.city.S
            }

            const axiosParams = {
                url: '/delete-poi',
                method: 'post',
                baseURL: config.API_URL,
                headers: {
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: essentialData
            };

            await axios(axiosParams);
            notificationSuccess('Punto di interesse Eliminato');

            await props.getPois();
            props.handleCloseDeletePoiDialog();
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    return (
        <Dialog className="" open={props.openDeletePoiDialog} onClose={props.handleCloseDeletePoiDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Elimina punto di interesse - {props?.lastCellData?.idEntita.S}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Vuoi eliminare il punto di interesse "{props?.lastCellData?.itname.S || ''}" con id {props?.lastCellData?.idEntita.S}?
                </DialogContentText>
                <DialogContentText>L'azione è irreversibile.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={deletePoi}>
                    Elimina
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseDeletePoiDialog}>
                    Annulla
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DeletePoiDialog